import React, {useState,useEffect} from 'react';
import Modal from "../../../../components/MuiComponents/Modal";
import QrScreen from "./QrScreen";
import {useDispatch, useSelector} from "react-redux";
import Otp from "./Otp";
import SuccessContent from "../SignupModal/SuccessContent";
import {grantAccess} from "../../../../actions/authActions";
import {setAuthInputs} from "../../../../redux/reducers/auth";

const TFA = props => {
    let {user, token} = useSelector(state => state.auth)
    const [screen, setScreen] = useState(user.tfa_enabled ? "otp" : "qr_screen")
    const dispatch = useDispatch()
    const close = () => {
        grantAccess(token, user)
    }
    const onClose = () => {
        dispatch(setAuthInputs({
            openAuthenticatorModal: false
        }))
    }

    useEffect(() => {
        if (screen === 'success') {
          const autoGoToDashboard = setTimeout(() => {
            grantAccess(token, user)
          }, 1500);
          return () => clearTimeout(autoGoToDashboard);
        }
    }, [screen, token, user]);

    return (
        <Modal open={true} maxWidth={"xs"} PaperProps={{className: '!max-w-[476px]'}}>
            {screen === "qr_screen" && <QrScreen {...{setScreen}}/>}
            {screen === "otp" && <Otp {...{setScreen}} />}
            {
                screen === "success" &&
                <SuccessContent
                    title={"Your authentication code <nobr>is verified!</nobr>"}
                    // body={"You can now Sign In using your email id <nobr>and password</nobr>"}
                    body={""}
                    buttonText={"CONTINUE"}
                    close={close}
                />
            }
        </Modal>
    );
};

export default TFA;
